import type { ReactNode } from 'react';
import { Card, Group, Title, Text, Stack } from '@mantine/core';

export function SectionCard({
  title,
  hint,
  right,
  children,
}: {
  title: string;
  hint?: string;
  right?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card padding="lg" radius="lg" withBorder h="100%">
      <Group justify="space-between" align="flex-start" mb="md" wrap="nowrap">
        <div>
          <Title order={5} c="navy.9" fw={600}>
            {title}
          </Title>
          {hint && (
            <Text size="xs" c="dimmed" mt={2}>
              {hint}
            </Text>
          )}
        </div>
        {right}
      </Group>
      <Stack gap="md">{children}</Stack>
    </Card>
  );
}
